export default {
  apiGateway: {
    REGION: "eu-west-2",
    URL: "https://api.datastar.software/v1"
    //URL: "https://f7iae0hf22.execute-api.eu-west-2.amazonaws.com/TST"
  },
  cognito: {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_0m4h7aQFg",
    IDENTITY_POOL_ID: "eu-west-2:054b50cd-dada-4d05-bb76-7d87c74068ac",
    APP_CLIENT_ID: "7d0d6a8n1t6092u04trcslhc7m"
  }
};
